<template>
  <div class="about">
    <div class="about-banner">
      <div class="container">
        <div class="about-banner-content">
          <p class="about-banner-content-title">我们是谁</p>
          <p class="about-banner-content-desc">我们致力于做免费IT入门课程，让每个人都会点编程</p>
        </div>
      </div>
    </div>
    <section class="brief-introduction">
      <div class="container">
        <div class="section-heading text-center">
          <h2 class="section__title ">我们的简介</h2>
          <span class="section__divider"></span>
        </div>
        <h4>回车课堂是博学谷旗下的免费互动学习平台。</h4>
        <p>博学谷是传智播客旗下高端IT在线教育平台，凭借传智播客黑马程序员线下十多年的一线教学经验及资深专家团队的教研力量，打造一套适合线上学习的课程以及教学服务体系。主要提供的是IT方面的大课以及全方位的教学服务和就业指导，帮助你全面掌握某一门重要IT技能。800余名老师联袂教学，专职班主任老师360°暖心陪伴、督促学习，专职技术老师全天候在线答疑解惑，一对一辅导并提供直播串讲。私人订制专属学习模式，智能化在线学习系统，以学习反馈为驱动教学。目前开设的学科有：<span>Java、Python、前端、大数据、人工智能、UI设计、软件测试、PHP、C/C++、新媒体+短视频运营、产品经理、电商运营、Linux云计算+运维开发、少儿编程讲师、PMP、影视制作等</span>课程。开设的学科紧跟时代的发展，不断更新迭代，因所开设课程技术新、课程深、项目广，让学员始终走在技术的前沿。</p>
        <p style="margin-top: 30px;">回车课堂是以一种全新的互动学习模式，将现有的学科的基础知识以一种极有趣的情景模式演绎出来，课堂里集学、练、测、问、记一体式模式来帮助你全方位理解课程内容。我们专注教育，主要致力于做<span>免费的IT基础入门</span>课程，想在互联网时代能让每个人都可以低门槛的获得编程相关、IT相关的知识。</p>
        <ul class="icon-list">
          <li v-for="(item,index) in iconList" :key="index">
            <img :src="item.imageUrl" alt="">
            <span>{{item.content}}</span>
          </li>
        </ul>
      </div>
    </section>
    <section class="our-desire">
      <div class="container">
        <div class="section-heading text-center">
          <h2 class="section__title ">我们的愿景</h2>
          <span class="section__divider"></span>
        </div>
        <h4>"有趣易学，人人都可以学编程"</h4> 
        <p>编程是可以改变世界的，知识也是可以改变一个人的命运的。在这个信息越来越爆炸的时代，随着知识付费的兴起，让人觉得只有付费的才是好的，免费的肯定充满了套路，所以我们就想做一个免费的没有任何套路的可以供大家获取IT技能知识的平台，让人人都懂一点编程知识。致力于改变自己的生活，致力于让这个世界变得更美好，这是任何一款产品诞生的初心。</p>
      </div>
    </section>
    <section class="join-us">
      <div class="container">
        <div class="section-heading text-center">
          <h2 class="section__title section__title2">加入我们</h2>
          <span class="section__divider section__divider2"></span>
          <p>如果你有梦想，如果你也是个在互联网行业摸爬滚打多年还没被摧残的老腊肉，哦，不，是有志青年，有很多的技术沉淀和心得，可以加入我们，为这个平台添砖加瓦，给自己赚取一份额外收入，也可收获志同道合的朋友。</p>
          <div class="channel btn-animate" @click="toLink()">加入通道</div>
        </div>
      </div>
    </section>
    <section class="contact-us">
      <div class="container">
        <div class="section-heading text-center">
          <h2 class="section__title ">联系我们</h2>
          <span class="section__divider"></span>
        </div>
        <div class="contact-content">
          <ul class="company-info">
            <li v-for="(item,index) in companyList" :key="index">
              <p>{{item.name}}</p>
              <span>{{item.cont}}</span>
              <img v-if="item.imgUrl" :src="item.imgUrl" alt="">
            </li>
          </ul>
          <div class="map-box">
            <img src="@/image/about/pic-map.png" alt="">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import("@/assets/style.css");
export default {
  name: 'about',
  data() {
    return {
      iconList:[
        {
          imageUrl:require('@/image/about/icon-about-01.png'),
          content:"全部内容免费"
        },
        {
          imageUrl:require('@/image/about/icon-about-02.png'),
          content:"内容从零基础开始"
        },
        {
          imageUrl:require('@/image/about/icon-about-03.png'),
          content:"有趣的互动式学习"
        },
        {
          imageUrl:require('@/image/about/icon-about-04.png'),
          content:"200+编程课，及时更新"
        },
      ],
      companyList:[
        {
          name:"公司",
          cont:"北京传智播客教育科技有限公司",
        },
        {
          name:"地址",
          cont:"北京市昌平区建材城西路传智播客办公楼",
        },
        {
          name:"邮箱",
          cont:"hdketang@itcast.cn",
        },
        {
          name:"公众号",
          cont:"关注我们，反馈你想对我们说的",
          imgUrl:require('@/image/course/gzh-qrcode.jpg')
        },
      ]
    }
  },
  methods:{
    toLink(){
      window.open("https://www.wjx.cn/vj/wu9pCKB.aspx")
    }
  }
}
</script>

<style lang="less" scoped>
.about{
  .about-banner{
    background-image:url("../image/about/about-banner.png");
    background-position: center center;
    background-size: cover;
    height: 300px;
    display: flex;
    align-items: center;
    .about-banner-content{
      margin: 0 auto;
      color: #fff;
      .about-banner-content-title{
        font-size: 32px;
        font-weight: 600;
        margin-bottom: 16px;
      }
      .about-banner-content-desc{
        font-size: 18px;
        border:1px solid #fff;
        border-radius: 20px;
        padding: 6px 18px;
        display: inline-block;
      }
    }
  }

  // 我们的简介 / 我们的愿景
  .brief-introduction,.our-desire{
    background: #fff;
    padding-top: 80px;
    .section-heading{
      .section__title{
        line-height: 65px;
        font-size: 46px;
        color: #2a3c60;
      }
    }
    h4{
      margin: 35px 0 50px;
      font-size: 28px;
      color: #25c48b;
      line-height: 40px;
      text-align: center;
    }
    p{
      font-size: 16px;
      line-height: 32px;
      color: #2a3c60;
      span{
        font-weight: 600;
      }
    }
    .icon-list{
      margin-top: 30px;
      // padding: 0 50px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li{
        width: 120px;
        position: relative;
        padding-bottom: 55px;
        margin:30px 50px 0;
        img{
          width: 120px;
          height: 120px;
          display: block;
          margin: 0 auto;
        }
        span{
          position: absolute;
          bottom:0;
          left: 50%;
          transform: translateX(-50%);
          line-height: 25px;
          display: block;
          text-align: center;
          white-space: nowrap;
          color: #2a3c60;
          font-size: 18px;
        }
      }
    }
  }
  // 我们的愿景
  .our-desire{
    padding: 120px 0 60px;
  }

  // 加入我们
  .join-us{
    background: url(../image/about/about-join-us.png) no-repeat;
    background-size: cover;
    background-position: center;
    padding: 60px 0 120px;
    .section-heading{
      .section__title{
        line-height: 65px;
        font-size: 46px;
        color: #fff;
      }
    }
    p{
      font-size: 16px;
      line-height: 32px;
      color: #ffffff;
      text-align: left;
    }
    .channel{
      width: 150px;
      margin: 40px auto 0
    }
  }

  // 联系我们
  .contact-us{
    padding-top: 80px;
    padding-bottom: 100px;
    .section-heading{
      .section__title{
        line-height: 65px;
        font-size: 46px;
        color: #2a3c60;
      }
    }
    .contact-content{
      margin-top: 35px;
      display: flex;
      background: #fff;
      .company-info{
        width: 420px;
        padding:40px 0 40px 60px;
        li{
          margin-top: 40px;
          p{
            position: relative;
            padding-left: 32px;
            line-height: 25px;
            color: #25c48b;
            font-size: 18px;
            &:after{
              position: absolute;
              display: block;
              content:"";
              left:0;
              top:0;
            }
          }
          span{
            margin-top: 14px;
            display: inline-block;
            color: #2a3c60;
            line-height: 22px;
            font-size: 16px;
          }
          img{
            width: 120px;
            height: 120px;
            margin-top: 30px;
            display:block;
          }
        }
        li:nth-of-type(1){
          margin:0;
          p{
            &:after{
              width: 20px;
              height: 18px;
              top: 1px;
              background:url(../image/about/icon-01.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        li:nth-of-type(2){
          p{
            &:after{
              width: 20px;
              height: 18px;
              top: 1px;
              background:url(../image/about/icon-02.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        li:nth-of-type(3){
          p{
            &:after{
              width: 20px;
              height: 16px;
              top: 2px;
              background:url(../image/about/icon-03.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        li:nth-of-type(4){
          p{
            &:after{
              width: 21px;
              height: 19px;
              top: 0.5px;
              background:url(../image/about/icon-04.png) no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .map-box{
        flex: 1;
        background: url(../image/about/pic-map.png) no-repeat;
        background-position: center center;
        background-size: cover;
        img{
          display: none;
        }
      }
    }
    @media (max-width: 1000px) {
      .company-info{
        width: auto !important;
        padding: 20px !important;
      }
    }
    @media (max-width: 720px) {
      .contact-content{
        display: block;
      }
      .company-info{
        width: 100% !important;
        padding: 20px !important;
      }
      .map-box{
        width: 100%;
        img{
          width: 100%;
          display: block !important;
        }
      }
    }
  }


}
// 带动画的按钮
.btn-animate{
  position: relative;
  height: 55px;
  text-align: center;
  line-height: 55px;
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  background: #25C48B;
  border-radius: 4px;
  overflow: hidden;
  &::after{
    position: absolute;
    top:0;
    left:-10px;
    content:"";
    display: block;
    transform: skewX(25deg);
    width: 56%;
    height: 100%;
    background-color: #fff;
    opacity: .1;
    transition: .3s ease-in;
  }
  &:hover{
    &::after{
      opacity: .2;
      width: 100%;
      left:0;
      transform: skewX(0deg);
    }
  }
}


@media (max-width: 1199px) {
  .container{
    max-width: 100% !important;
  }
}

@media (max-width: 600px) {
  .section-heading{
    .section__title{
      line-height: 45px !important;
      font-size: 35px !important;
    }
  }
  h4{
    margin: 25px 0 35px !important;
    font-size: 22px !important;
    line-height: 34px !important;
  }
}
</style>